const init = function () {
    const page = document.querySelector('[data-page="cash_order_form"]');
    if (!page) {
        return;
    }

    const button = document.getElementById('btn_recalculate');
    const clientIdInput = document.getElementById('id_klient');
    const sumInput = document.getElementById('Summa');
    const sumGrnInput = document.getElementById('Summa_grn');
    const paymentBasisInput = document.getElementById('vid_nakl');

    if (!button || !clientIdInput || !page.dataset.routeRecalculatePayments) {
        return;
    }

    button.addEventListener('click', async () => {
        const clientId = clientIdInput.value;
        if (!clientId) {
            alert('Выберите клиента.');
            return;
        }

        const originalText = button.innerHTML;
        button.disabled = true;
        button.innerHTML = '<span class="spinner-border spinner-border-sm"></span> Пересчет...';

        try {
            const response = await fetch(page.dataset.routeRecalculatePayments, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                },
                body: JSON.stringify({clientId}),
            });

            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.message || 'Не удалось выполнить пересчет.');
            }

            if (window.cashOrderFormSetCalculations) {
                window.cashOrderFormSetCalculations(data.summary);
            }

            fillCurrentPaymentFields(data.summary);

            if (window.cashOrderFormReload) {
                window.cashOrderFormReload();
            }
        } catch (error) {
            alert(error.message);
        } finally {
            button.disabled = false;
            button.innerHTML = originalText;
        }
    });

    function fillCurrentPaymentFields(summary) {
        const balance = parseFloat(summary.balance || 0);
        const balanceGrn = parseFloat(summary.balanceGrn || 0);

        if (balance === 0 && balanceGrn === 0) {
            sumInput.value = '0.00';
            sumGrnInput.value = '0.00';
            return;
        }

        sumInput.value = Math.abs(balance).toFixed(2);
        sumGrnInput.value = Math.abs(balanceGrn).toFixed(2);

        if (balance > 0) {
            paymentBasisInput.value = page.dataset.paymentBasisClientPaysForSalesInvoice;
        } else {
            paymentBasisInput.value = page.dataset.paymentBasisPaymentToSupplierForPurchaseInvoice;
        }
    }
};

export default {init};
